import { useRouter as useHistory } from 'next/router';

export const useRouter = () => {
  const history = useHistory();
  return history;
};
